import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <div className={styles.loaderWrapper}>
      <div className={styles.spinnerWrapper}>
        <div className={styles.loader}></div>
      </div>
    </div>
  );
};

export default Loader;
